"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instalment = void 0;
const tslib_1 = require("tslib");
const Entity_1 = require("../../../core/domain/Entity");
const Guard_1 = require("../../../core/logic/Guard");
const Instalment_validator_1 = tslib_1.__importDefault(require("./Instalment.validator"));
class Instalment extends Entity_1.Entity {
    constructor(p, ref, id) {
        super(p, ref, id);
    }
    static validate(raw, ref, id) {
        try {
            Instalment_validator_1.default(raw);
            return Guard_1.Guard.pass();
        }
        catch (e) {
            Entity_1.Entity.handleValidationError(e, ref, id);
            return Guard_1.Guard.fail(e.message);
        }
    }
    static create(p, ref, id) {
        return new Instalment(p, ref, id);
    }
}
exports.Instalment = Instalment;
//# sourceMappingURL=Instalment.js.map